import React, {useState} from 'react';
import Icon from '../../components/Icon';
import {useMutation} from '@apollo/client';
import {MUTATION_USER_CODE, MUTATION_USER_RESTORE} from '../User/graphql';

const Login = ({login, loading, error, user, userLoading}) => {
  const [page, setPage] = useState(null);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [restoreCode, setRestoreCode] = useState('');

  const [code, codeResp] = useMutation(MUTATION_USER_CODE, {
    onCompleted: data => {
      if (data.userCode.obj) {
        setPage('RESTORE');
      }
    },
  });

  const [restore, restoreResp] = useMutation(MUTATION_USER_RESTORE, {
    onCompleted: data => {
      if (data.userRestore.obj) {
        setPage(null);
      }
    },
  });

  if (page === 'RESTORE') {
    return (
      <div>
        <div className="mb-3 mt-4 text-left">
          <div className="mb-2">Email</div>
          <input
            value={username}
            onChange={e => setUsername(e.target.value)}
            type="text"
            className="form-control form-control-lg font-4"
          />
        </div>
        <div className="mb-3 mt-4 text-left">
          <div className="mb-2">Код из почты</div>
          <input
            value={restoreCode}
            onChange={e => setRestoreCode(e.target.value)}
            type="text"
            className="form-control form-control-lg font-4"
          />
        </div>
        <div className="mb-3 mt-4 text-left">
          <div className="mb-2">Придумайте новый пароль</div>
          <input
            value={password}
            onChange={e => setPassword(e.target.value)}
            type="text"
            className="form-control form-control-lg font-4"
          />
        </div>
        <button
          className="btn btn-primary btn-lg d-block mt-4 w-100 font-4"
          onClick={() => restore({variables: {input: {username: username.toLowerCase(), restoreCode, password}}})}
        >
          {restoreResp.loading ? `Восстановить пароль...` : `Восстановить пароль`}
        </button>
        <div style={{height: 30}} className="mt-3 font-2 text-danger text-center">
          {restoreResp.error && restoreResp.error.non_field_errors}
        </div>
        <button onClick={() => setPage(null)} className="btn btn-link">
          Назад к логину
        </button>
      </div>
    );
  }

  if (page === 'CODE') {
    return (
      <div>
        <div className="mb-3 mt-4 text-left">
          <div className="mb-2">Email для восстановления</div>
          <input
            value={username}
            onChange={e => setUsername(e.target.value)}
            type="text"
            className="form-control form-control-lg font-4"
          />
        </div>
        <button
          className="btn btn-primary btn-lg d-block mt-4 w-100 font-4"
          onClick={() => code({variables: {input: {username: username.toLowerCase()}}})}
        >
          {codeResp.loading ? 'Отправить код...' : `Отправить код`}
        </button>
        <div style={{height: 30}} className="mt-3 font-2 text-danger text-center">
          {codeResp.error && codeResp.error.non_field_errors}
        </div>
        <button onClick={() => setPage(null)} className="btn btn-link">
          Назад к логину
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-3 mt-4 text-left">
        <div className="mb-2">Email</div>
        <input
          value={username}
          onChange={e => setUsername(e.target.value)}
          type="text"
          className="form-control form-control-lg font-4"
        />
      </div>
      <div className="mb-4 text-left">
        <div className="mb-2">Пароль</div>
        <input
          value={password}
          onChange={e => setPassword(e.target.value)}
          type="password"
          className="form-control form-control-lg font-4"
        />
      </div>
      <button
        className="btn btn-primary btn-lg d-block mt-4 w-100 font-4"
        onClick={() => login({username: username.toLowerCase(), password})}
      >
        {loading || userLoading ? `Отправка...` : `Логин`}
      </button>
      <div style={{height: 30}} className="mt-3 font-2 text-danger text-center">
        {error && error.non_field_errors}
        {!loading && !error && user && user.role !== 'CLIENT' ? 'Permission denied.' : null}
      </div>
      <button onClick={() => setPage('CODE')} className="btn btn-link">
        Забыли пароль?
      </button>
    </div>
  );
};

export default Login;
